import { NetworkService } from '../../../../services/networkService';
import { getMultiValuesQueryString } from '../../../../utility/urlQuery';
import { getDateLabels, getVariousDates } from '../../../../utility/date';

const productTypes = [
  {
    key: 'all',
    title: 'All Listings',
  },
  {
    key: 'premium',
    title: 'Basic',
  },
  {
    key: 'hot',
    title: 'Hot',
  },
  {
    key: 'superhot',
    title: 'Signature',
  },
];
const phoneStatsMapper = (data, dateArray) => {
  const mappedData = {
    calls_received: {
      responseKey: 'received_calls',
      borderColor: '#55969B',
      label: 'Calls Received',
      total: data?.received_calls,
    },
    calls_answered: {
      responseKey: 'answered_calls',
      borderColor: '#28B16D',
      label: 'Calls Answered',
      total: data?.answered_calls,
    },
    calls_missed: {
      responseKey: 'missed_calls',
      borderColor: '#F7ADA0',
      label: 'Calls Missed',
      total: data?.missed_calls,
    },
  };

  Object.keys(mappedData).forEach((categoryKey) => {
    mappedData[categoryKey] = {
      ...mappedData[categoryKey],

      ...productTypes.reduce((acc, { key: productKey }) => {
        acc[productKey] = [];
        return acc;
      }, {}),
    };
  });

  dateArray.map((dateKey) => {
    Object.keys(mappedData).forEach((categoryKey) => {
      productTypes?.forEach((productType) => {
        if (productType?.key == 'all') {
          const value = data?.items?.[dateKey]?.[mappedData?.[categoryKey]?.responseKey] || 0;
          mappedData[categoryKey]['all'].push(value);
        } else {
          const value =
            data?.items?.[dateKey]?.product_wise?.find((product) => product?.ad_product == productType?.key)?.[
              mappedData?.[categoryKey]?.responseKey
            ] || 0;
          mappedData[categoryKey]?.[productType?.key].push(value);
        }
      });
    });
  });

  return mappedData;
};
export const getPhoneStats = async (params) => {
  const { date_between = getVariousDates(29) } = params;
  const startDate = typeof date_between === 'string' ? date_between?.split(',')?.[0] : date_between?.[0];
  const endDate = typeof date_between === 'string' ? date_between?.split(',')?.[1] : date_between?.[1];
  const dateArray = getDateLabels(startDate, endDate, 'YYYY-MM-DD');

  const paramsObj = {
    start_datetime: startDate,
    end_datetime: endDate,
    'group_by[]': 'date,ad_product',
    'agency_external_ids[]': params?.['agency_external_ids[]'],
    'user_external_ids[]': params?.['user_external_ids[]'],
  };

  const response = await NetworkService.get(
    `/api/lms/stats/phone_lead_stats?${getMultiValuesQueryString(paramsObj)}&${
      !params?.purpose || params?.purpose === 'all'
        ? `category_ids[]=1&category_ids[]=2`
        : `category_ids[]=${params?.purpose == 'sale' ? 1 : params?.purpose == 'rent' ? 2 : params?.purpose == 'dailyrental' ? 4 : params?.purpose}`
    }`,
  );

  if (response) {
    if (response.error) {
      return response;
    } else if (response?.data) {
      return phoneStatsMapper(response?.data?.stats, dateArray);
    }
  }
};
